export const BROADCAST_CHANNEL_NAME = 'maxui';

export const BROADCAST_EVENTS = {
  DOCUMENT_APPROVED: 'maxui.document.approved',
  TASK_UPDATED: 'maxui.task.updated',
  APP_RELEASE_READY: 'maxui.app.releaseReady',
} as const;

// Posted to the service worker directly, not on the broadcast channel.
export const SW_MESSAGES = {
  TAB_RELEASE: 'maxui.sw.tabRelease',
} as const;

export type BroadcastEventName =
  (typeof BROADCAST_EVENTS)[keyof typeof BROADCAST_EVENTS];
